<template>
  <div class="stop-related-data">
    <div class="stop-dumping__text">
      <p>
        <span class="material-icons">{{ icon }}</span>
        <span>{{ $t(`routes.${title}`) }}:</span>
      </p>
      <div v-if="attachmentType == 'comment' && stop.comment">{{ stop.comment.body }}</div>
      <ul v-if="attachmentType == 'dumped_weights'">
        <li v-for="(weight, chamber) in stop.dumped_weights" :key="chamber">{{ chamber }}: {{ weight }} kg.</li>
      </ul>
      <ImageComponent
        v-if="attachmentType == 'image' && stop.position_type !== 'dumping'"
        :preview="stop.image.preview_url"
        :src="stop.image.url"
        :height="'100'"
      />
      <small v-if="attachmentType == 'comment' && stop.comment">
        – {{ formattedFromDateTime(stop.comment.created_at) }}
      </small>
      <small v-if="attachmentType == 'dumped_weights'">– {{ formattedFromDateTime(stop.updated_at) }}</small>
    </div>
    <div v-if="stop.position_type === 'dumping' && stop.image">
      <ImageComponent
        v-if="attachmentType == 'image' && stop.position_type !== 'dumping'"
        :preview="stop.image.preview_url"
        :src="stop.image.url"
        :height="'100'"
      />
    </div>
  </div>
</template>

<script>
import ImageComponent from '@/components/Image.vue'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'StopAttachment',
  props: {
    stop: { type: Object, required: true },
    attachmentType: { type: String, default: 'comment' },
  },
  components: { ImageComponent },
  mixins: [dateUtils],
  computed: {
    icon() {
      if (this.attachmentType == 'comment') return 'chat'
      if (this.attachmentType == 'image') return 'photo_camera'
      return 'speaker_notes'
    },
    title() {
      if (this.attachmentType == 'comment') return 'commentedNotice'
      if (this.attachmentType == 'image') return 'imageNotice'
      return 'dumpingNotice'
    },
  },
}
</script>

<style lang="scss" scoped>
.stop-related-data {
  display: flex;
  justify-content: space-between;
  margin-top: 1.25rem;
  border: 2px dashed #f1f1f1;
  padding: 15px;
  border-radius: var(--border-radius-m);

  p {
    margin: 0 0 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }

  small {
    display: block;
    margin-top: 7px;
  }

  ul li {
    background: #fff;
    border: none;
    margin-bottom: 0;
    padding-top: 0;
  }
}

.stop-dumping {
  &__text {
    flex: 5;
  }

  &__image {
    flex: 2;

    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
